import { customFetchV2 } from './custom-fetch-v2';

class GeocoderService {
  // [lat, lng] -> address
  reverseCache = {};

  reverseGeocodeWithCache = (latitude, longitude) => {
    const key = [latitude, longitude];
    const address = this.reverseCache[key];
    if (address) {
      return Promise.resolve({
        latitude,
        longitude,
        address,
      });
    }

    return this.reverseGeocode(latitude, longitude).then((result) => {
      this.reverseCache[key] = result.address;
      return result;
    });
  };

  reverseGeocode = (latitude, longitude) => {
    const url = '/api/v2/geocoder/reverse-geocode';

    return customFetchV2(url, {
      method: 'POST',
      body: JSON.stringify({
        latitude,
        longitude,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Unable to complete reverse geocode for ${latitude},${longitude} - HTTP response ${response.status}`);
        }

        // The JSON received includes deviceKey attribs + location `segments`
        // which is an array of items where each item includes some block of
        // location data with start/end times and a URL source that has to
        // be retrieved.
        return response.data;
      });
  }
}

export default GeocoderService;
